import * as axios from 'axios';

export default function createBackend({
  httpClient,
  mqttClient,
  requestorId,
}: {
  httpClient: axios.AxiosInstance;
  mqttClient: any;
  requestorId: string;
}): Backend {
  return new Backend({ httpClient, mqttClient, requestorId });
}

export class Backend {
  requestorId: string;
  httpClient: axios.AxiosInstance;
  mqttClient: any;

  constructor({
    httpClient,
    mqttClient,
    requestorId,
  }: {
    httpClient: axios.AxiosInstance;
    mqttClient: any;
    requestorId: string;
  }) {
    this.requestorId = requestorId;
    this.httpClient = httpClient;
    this.mqttClient = mqttClient;
  }

  // Standard Gateway relies on this method to make HTTP requests
  axios(): axios.AxiosInstance {
    return this.httpClient;
  }

  subscribe(topic, onReceive, cb) {
    this.mqttClient.subscribe(topic, onReceive, cb);
  }

  unsubscribe(topic, onReceive) {
    this.mqttClient.unsubscribe(topic, onReceive);
  }

  on(event, listener) {
    this.mqttClient.on(event, listener);
  }

  removeListener(event, listener) {
    this.mqttClient.removeListener(event, listener);
  }

  connect(username, orgId) {
    this.mqttClient.connect(username, orgId);
  }
}
